export default __webpack_public_path__ + "static/media/wheel_loader.325a181b.jpg";